export const REVIEW_BUSINESS_REQUEST = `
  mutation ReviewBusinessRequest($input: ReviewBusinessRequestInput!) {
    reviewBusinessRequest(input: $input) {
      requestId
      status
      approvedAt
      approvedBy
      rejectedAt
      rejectedBy
      approvedRuntimePrincipals
      auditTrail
    }
  }
`
